import React, { createContext, useContext, useState } from 'react';

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const clientId = localStorage.getItem("clientId");
  const defaultValue = clientId === "310" ? false : true;

  const [globalParam, setGlobalParam] = useState(defaultValue);
  const setGlobalParameter = (value) => {
    setGlobalParam(value);
  };

  return (
    <GlobalContext.Provider value={{ globalParam, setGlobalParameter }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => {
  return useContext(GlobalContext);
};
